import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Layout } from './components/Layout';
import './custom.css';
import authService from './components/api-authorization/AuthorizeService';
import { User } from 'oidc-client';

// This interface must cover all possible route shapes in AppRoutes.
interface AppRoute {
    index?: boolean;
    path?: string;
    element: React.ReactNode;
    requireAuth?: boolean;
    roles?: string[];
    name?: string;
}

interface AppState {
    user: User | null;
    isAuthenticated: boolean;
}

export default class App extends Component<{}, AppState> {
  static displayName = App.name;
  
  _subscription: number | undefined;

  state: AppState = {
      user: null,
      isAuthenticated: false
  }

  componentDidMount() {
      this._subscription = authService.subscribe(() => this.populateState());
      this.populateState();
  }

  componentWillUnmount() {
      if (this._subscription) {
          authService.unsubscribe(this._subscription);
      }
  }

  async populateState() {
      const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
      this.setState({
          isAuthenticated,
          user
      });
  }

  render() {
    // We cast AppRoutes to our AppRoute type to work with it in a type-safe way.
    const routes = AppRoutes as AppRoute[];

    return (
      <Layout>
        <Routes>
          {routes.map((route, index) => {
            const { element, requireAuth, ...rest } = route;
            const routeElement = requireAuth ? <AuthorizeRoute {...rest} element={element} /> : element;
            return <Route key={index} {...rest} element={routeElement} />;
          })}
        </Routes>
      </Layout>
    );
  }
}
